import React from "react";
import ReactDOM from "react-dom";
import styles from "./Modal.module.css";

export default function Modal({ children, onClose = () => {} }) {
    return ReactDOM.createPortal(
        <>
            <div className={styles.background} onClick={onClose} />
            <div className={styles.container}>{children}</div>
        </>,
        document.getElementById("portal")
    );
}
